import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatBadgeModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { CompanyService } from '@fuse/services/company.service';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { NotificationsToolbarModule } from '@fuse/components/notifications-toolbar/notifications-toolbar.module';

@NgModule({
    declarations: [
        ToolbarComponent
    ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatBadgeModule,
        TranslateModule,

        NotificationsToolbarModule,

        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule
    ],
    providers: [
        CompanyService
    ],
    exports: [
        ToolbarComponent
    ]
})
export class ToolbarModule {
}
